<template>
  <div style="margin: 0 auto;">
    <div id="myChart" style="width: 300px;height: 300px;"></div>
    <div class="legend-content">
      <div class="item-legend">
        <span class="dot"></span>{{ h_i18n('ad96194e6dc6c4ef2c665c506b8b759f') }}</div>
      <div class="item-legend" style="margin-left: 24px;">
        <span class="dot" style="background: #F2F3F5;"></span>{{ h_i18n('1dd67f0d9e6a621b76c7c330cf408268') }}</div>  
    </div>
  </div>
</template>

<script>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';

import * as echarts from 'echarts'
export default {
  props:['pieData'],
  methods:{
    h_i18n,
    getInit(){
      console.log('this.pieData',this.pieData)
      let myChart = echarts.init(document.getElementById('myChart'))
      var option = {
        tooltip: {
          trigger: 'item'
        },
        title: {
          text: this.pieData,// 圆心显示的${75}%
          textStyle: {
            color: '#1D2129',
            fontSize: 24
          },
          subtext: h_i18n('4d7b168a15760baadbbb7385577f6f83'),
          subtextStyle: {
            color: '#4E5969',
          },
          itemGap: 10, // 主副标题距离
          left: 'center',
          top: 'center'
        },
        angleAxis: {
          max: 100, // 满分
          clockwise: true, // 逆时针
            // 隐藏刻度线
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: false
          },
          splitLine: {
            show: false
          }
        },
        radiusAxis: {
          type: 'category',
          // 隐藏刻度线
          axisLine: {
            show: false
            },
            axisTick: {
            show: false
            },
            axisLabel: {
            show: false
            },
            splitLine: {
            show: false
          }
        },
        polar: {
          center: ['50%', '50%'],
          radius: '140%' //图形大小
        },
        series: [{
          type: 'bar',
          showBackground: true,
          backgroundStyle: {
            color: '#F2F3F5'
          },
          data: [{
            name: h_i18n('4d7b168a15760baadbbb7385577f6f83'),
            value: this.pieData,
            itemStyle: {
              // fontSize: '24',
              // color: '#1D2129',
              normal: {
                color: '#165dff'
                // new echarts.graphic.LinearGradient(1, 0, 0, 0, [{
                //   offset: 0,
                //   color: '#aaf14f'
                // }, {
                //   offset: 1,
                //   color: '#0acfa1'
                // }])
              }
            },
          }],
          coordinateSystem: 'polar',
          roundCap: true,
          barWidth: 15,
          show: true
        },
       // { // 灰色环
        //    type: 'bar',
        //    data: [{
         //     value: 100,
        //      itemStyle: {
         //       color: '#e2e2e2',
         //       shadowColor: 'rgba(0, 0, 0, 0.2)',
         //       shadowBlur: 5,
         //       shadowOffsetY: 2
         //     }
          //  }],
          //  coordinateSystem: 'polar',
          //  roundCap: true,
          //  barWidth: 25,
          //  barGap: '-100%', // 两环重叠
          //  z: 1
         // }
        ]
      }
      myChart.setOption(option);
    }
  },
  mounted(){
    this.getInit()
  }
}
</script>

<style scoped>
.dot{
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 6px;
  background: #165dff;
}
.legend-content{
  display: flex;
  flex-direction: row;
  justify-content: center;
}
</style>